import styles from './mapblock.css'

type MapBlockProps = {
  value: {
    image: number
    url: string
  }
}

const MapBlock = ({ value: { image, url } }: MapBlockProps): JSX.Element => (
  <a
    className={styles.map}
    href={url}
    target="_blank"
    rel="noopener noreferrer"
    style={{ backgroundImage: `url("/is/${image}/fill-3000x1000/")` }}
  >
    {' '}
  </a>
)

export default MapBlock
